export const SET_LANGUAGE = 'common/SET_LANGUAGE';
export const GET_DISTRICT = 'common/GET_DISTRICT';
export const GET_PROVICE = 'common/GET_PROVICE';
export const GET_SHARE_INFO_REQUEST = 'GET_SHARE_INFO_REQUEST';
export const GET_SHARE_INFO_SUCCESS = 'GET_SHARE_INFO_SUCCESS';
export const GET_SHARE_INFO_FAILED = 'GET_SHARE_INFO_FAILED';
